import * as types from '../actions';

const initialState = {
    validateResponse:{},
    validateActivity:'',
    validateStatus:'',
    validateErrorData:'',
};

export default function(state = initialState, action) {
    const response = action.response;
    let timeVar = '~~'+Date.now(); 

    switch(action.type) {

        case types.VALIDATE_CLIENT_ADD_SUCCESS:
            return {
                ...state,
                validateResponse: response.data,
                validateStatus: response.status,  
                validateActivity: types.VALIDATE_CLIENT_ADD_SUCCESS+timeVar, 
            };
        case types.VALIDATE_CLIENT_ADD_ERROR:
            return {
                ...state,
                validateErrorData:response.data,
                validateStatus: response.status,  
                validateActivity:types.VALIDATE_CLIENT_ADD_ERROR+timeVar,                               
            };

        case types.VALIDATE_CLIENT_DETAILS_SUCCESS:
            return {
                ...state,
                validateResponse: response.data,
                validateStatus: response.status,  
                validateActivity: types.VALIDATE_CLIENT_DETAILS_SUCCESS+timeVar, 
            };
        case types.VALIDATE_CLIENT_DETAILS_ERROR:
            return {
                ...state,
                validateErrorData:response.data,
                validateStatus: response.status,  
                validateActivity:types.VALIDATE_CLIENT_DETAILS_ERROR+timeVar,                               
            };    
        
        case types.VALIDATE_EVENT_ADD_SUCCESS:
            return {
                ...state,
                validateResponse: response.data,
                validateStatus: response.status,  
                validateActivity: types.VALIDATE_EVENT_ADD_SUCCESS+timeVar, 
            };

        case types.VALIDATE_EVENT_ADD_ERROR:
            return {
                ...state,
                validateErrorData:response.data,
                validateStatus: response.status,  
                validateActivity:types.VALIDATE_EVENT_ADD_ERROR+timeVar,                               
            };    
        

        case types.VALIDATE_CREW_ADD_SUCCESS:  
            return {
                ...state,
                validateResponse: response.data,
                validateStatus: response.status,  
                validateActivity: types.VALIDATE_CREW_ADD_SUCCESS+timeVar, 
            };

        case types.VALIDATE_CREW_ADD_ERROR:
            return {
                ...state,
                validateErrorData:response.data,
                validateStatus: response.status,  
                validateActivity:types.VALIDATE_CREW_ADD_ERROR+timeVar,                               
            };

        case types.VALIDATE_CREW_DETAILS_SUCCESS:  
            return {
                ...state,
                validateResponse: response.data,
                validateStatus: response.status,  
                validateActivity: types.VALIDATE_CREW_DETAILS_SUCCESS+timeVar, 
            };

        case types.VALIDATE_CREW_DETAILS_ERROR:
            return {
                ...state,
                validateErrorData:response.data,
                validateStatus: response.status,  
                validateActivity:types.VALIDATE_CREW_DETAILS_ERROR+timeVar,                               
            };    


        default:
            return state;

    }
}